import { Grid, IconButton, Link, ListItem, Paper } from "@material-ui/core";
import { DeleteOutline } from "@material-ui/icons";
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import EmptyPlaceholder from "components/EmptyPlaceholder/EmptyPlaceholder";
import { IconCar } from "icons";
import { AutoSizer } from "react-virtualized";
import { VariableSizeList } from "react-window";
import NotificationProvider from "../../../../../components/NotificationProvider";
import usePrompt from "../../../../../hooks/usePrompt";
import { useDeleteVehicleMutation } from "../../../reservationSlice";
import { ReservationVehicleStyles } from "./ReservationVehicleStyles";
import { paveCheckinStatus, paveCheckinStatusLabel } from "features/Reservation/reservationConsts";

export const ReservationVehicleList = ({ vehiclesList, reservationId }) => {
  let [removeVehicle, { isLoading: removingLot }] = useDeleteVehicleMutation();
  const { triggerPrompt } = usePrompt();
  const classes = ReservationVehicleStyles();

  const getItemSize = (index) => {
    let height = 150;
    const v = vehiclesList?.[index];
    if (v?.paveCheckInInformation) {
      height = 200
    }
    return height;
  }


  const onDelete = async (activeVehicleId) => {
    triggerPrompt({
      title: "Remove Vehicle from Reservation",
      content: "Are you sure you want to remove the Vehicle from Reservation?",
      onConfirm: async () => {
        let body = {
          vehicleId: activeVehicleId,
          reservationId: reservationId,
        };
        const res = await removeVehicle(body);
        if (res?.error) {
          NotificationProvider.error("Failed to remove Vehicle from the reservation");
        } else {
          NotificationProvider.success("The vehicle was removed from the reservation");
        }
      },
    });
  };

  const Row = ({ index, style }) => {
    const activeVehicle = vehiclesList?.[index];
    return (
      <ListItem key={index} style={style}>
        <Paper className={classes.listItemWrapper}>
          <Grid item>
            <Grid container alignItems="center">
              <Grid item className={classes.itemIcon}>
                <IconCar />
              </Grid>
              <Grid item>
                <Grid container direction="column">
                  {activeVehicle.vin && (
                    <Grid item>
                      <label className={classes.itemLabel}> VIN: </label>
                      <Link target='_blank' href={`/assets/detail/${activeVehicle?.id}`} className={classes.link}>{activeVehicle.vin}</Link>
                    </Grid>
                  )}
                  {activeVehicle.assetId && (
                    <Grid item>
                      <label className={classes.itemLabel}> Asset ID: </label>
                      <Link target='_blank' href={`/assets/detail/${activeVehicle?.id}`} className={classes.link}>{activeVehicle.assetId}</Link>
                    </Grid>
                  )}
                  {activeVehicle.licensePlate && (
                    <Grid item>
                      <label className={classes.itemLabel}>
                        {" "}
                        License Plate:{" "}
                      </label>
                      <Link target='_blank' href={`/assets/detail/${activeVehicle?.id}`} className={classes.link}>{activeVehicle.licensePlate}</Link>
                    </Grid>
                  )}
                  {activeVehicle.status && (
                    <Grid item>
                      <label className={classes.itemLabel}> Status: </label>
                      {activeVehicle.status}
                    </Grid>
                  )}
                  {activeVehicle.paveCheckInInformation && (
                    <Grid item>
                      <label className={classes.itemLabel}> PAVE: </label>
                      {paveCheckinStatusLabel[activeVehicle.paveCheckInInformation?.status]}
                      {!activeVehicle.paveCheckInInformation?.paveResultsUrl && activeVehicle.paveCheckInInformation?.paveUrl && <a className={classes.paveLink} href={activeVehicle.paveCheckInInformation?.paveUrl} target="_blank">PAVE Url</a>}
                      {activeVehicle.paveCheckInInformation?.paveResultsUrl && <a className={classes.paveLink} href={activeVehicle.paveCheckInInformation?.paveResultsUrl} target="_blank">PAVE Results</a>}
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Authorize profile={permissionProfiles.RESERVATIONS.EDIT}>
                <IconButton className={classes.deleteIcon}
                  title={"Delete"}
                  onClick={() => onDelete(activeVehicle.id)}
                >
                  <DeleteOutline />
                </IconButton>
              </Authorize>
            </Grid>
          </Grid>
        </Paper>
      </ListItem>
    );
  };

  return (
    <>
      {vehiclesList?.length > 0 ? (
        <div className={classes.listWrapper}>
          <AutoSizer>
            {({ height, width }) => (
              <VariableSizeList
                className="List"
                height={height}
                itemCount={vehiclesList?.length || 0}
                itemSize={getItemSize}
                width={width}
                itemKey={(index) => vehiclesList[index]?.reservationVehicleId}
              >
                {Row}
              </VariableSizeList>
            )}
          </AutoSizer>
        </div>
      ) : (
        <EmptyPlaceholder
          text={"Vehicle list is empty"}
          className={classes.listWrapper}
        />
      )}
    </>
  );
};
